import { AES, enc, lib, pad, mode } from 'crypto-js';

const SECRET_KEY = 'secretKey@8833';
export const encryptData = (data) => {
    const encryptedData = AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
    return encryptedData;
    // const iv = lib.WordArray.random(16);
    // const encrypted = AES.encrypt(JSON.stringify(data), enc.Utf8.parse(SECRET_KEY), {
    //   iv: iv,
    //   padding: pad.Pkcs7,
    //   mode: mode.CBC
    // });
    // const ivAndCiphertext = iv.concat(encrypted.ciphertext);
    // return enc.Base64.stringify(ivAndCiphertext);
};

export const decryptData = (data) => {
    const decryptedData = AES.decrypt(data, SECRET_KEY).toString(enc.Utf8);
    return JSON.parse(decryptedData);
    // const ivAndCiphertext = enc.Base64.parse(data);
    // const iv = lib.WordArray.create(ivAndCiphertext.words.slice(0, 4));
    // const ciphertext = lib.WordArray.create(
    //   ivAndCiphertext.words.slice(4)
    // );
 
    // const decrypted = AES.decrypt(
    //   { ciphertext: ciphertext },
    //   enc.Utf8.parse(SECRET_KEY),
    //   { iv: iv, padding: pad.Pkcs7, mode: mode.CBC }
    // );
    // return decrypted.toString(enc.Utf8);
};